const routes = [
  {
    path: '/',
    redirect: 'HomePage',
    component: () => import('@/view/homePage/index.vue')
  },
  {
    path: '/homePage',
    name: 'HomePage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/homePage/index.vue')
    }
  },
  {
    path: '/myProject',
    name: 'myProject', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/my/index.vue')
    }
  },
  {
    path: '/departmentNo',
    name: 'departmentNo', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/department/index.vue')
    }
  },
  {
    path: '/departmentList/:id',
    name: 'departmentList', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/departmentList/index.vue')
    }
  },
  {
    path: '/searchPage',
    name: 'searchPage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/searchPage/index.vue')
    }
  },
  {
    path: '/entrancePage',
    name:'entrancePage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/entrance/index')
    }
  },
  {
    path: '/pictureShow',
    name:'pictureShow', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/pictureShow/index')
    }
  },
  {
    path: '/expertsPage',
    name:'expertsPage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/experts/index')
    }
  },
  {
    path: '/expertsDetail/:id',
    name: 'expertsDetail', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/expertsDetail/index')
    }
  },
  {
    path: '/registerPage',
    name: 'registerPage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/register/index')
    }
  },
  {
    path: '/programAgenda',
    name:'programAgenda', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/programAgenda/index')
    }
  },
  {
    path: '/onlinePage',
    name: 'onlinePage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/online/index')
    }
  },
  {
    path: '/onlineExhibitionHall',
    name: 'onlineExhibitionHall', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/onlineExhibitionHall/index')
    }
  },
  {
    path: '/onlineExhibitionHallDetail/:id',
    name: 'onlineExhibitionHallDetail', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/onlineExhibitionHallDetail/index')
    }
  },
  {
    path: '/trafficPage',
    name: 'trafficPage', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/traffic/index')
    }
  },
  {
    path: '/pictureLiveBroadcast',
    name: 'pictureLiveBroadcast', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/pictureLiveBroadcast/index')
    }
  },
  {
    path: '/pictureLiveBroadcastDetail/:id',
    name: 'pictureLiveBroadcastDetail', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/pictureLiveBroadcastDetail/index')
    }
  },
  {
    path: '/pictureLiveBroadcastListDetail/:id',
    name: 'pictureLiveBroadcastListDetail', // 命名路由，可以用于声明式导航传参
    components: {
      default: () => import('@/view/pictureLiveBroadcastListDetail/index')
    }
  }
]

// 关键点：确保默认导出的是数组
export default routes
